<template>
  <div class="screen">
    <v-btn class="primary" dark>
      Start presentation
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StartPresentation',

  data() {
    return {};
  },

  computed: mapGetters([
    'userId'
  ])
};
</script>



// WEBPACK FOOTER //
// src/pages/StartPresentation.vue